import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import Header from './header/Header'
import Footer from './footer/Footer'
import './Layout.scss'
import Modal from 'components/modal/Modal'
import GlobalScripts from 'global/GlobalScripts'
import { userContext } from 'global/context/sub-contexts/userContext'
import { getProfileInfo } from 'services/profile'
import sessionStorageWrapper from 'util/SessionStorageWrapper'

import 'site.scss'
import 'global/site-specific.scss'

const Layout = ({ children, hideNav, hideFooter }) => {
  const user_context = useContext(userContext)
  const { logout, setProfile, setPoints, setSweepsEntries, isLoggedInBoolean } =
    user_context || {}

  useEffect(() => {
    if (isLoggedInBoolean) {
      getProfileInfo()
        .then(response => {
          const { user, badges, sweepsEntries } = response.detail

          setProfile(user)
          setSweepsEntries(sweepsEntries)
          setPoints(user.points)

          if (typeof window !== `undefined`) {
            window.dataLayer.push({
              user: {
                uid: user.id,
                age: user.age,
                date_of_registration: user.registrationDate,
                is_guest: user.guest,
                zip: user.zip,
                gender: user.gender,
                state: user.state,
                original_utm_campaign: user.utm_campaign,
                original_utm_content: user.utm_content,
                original_utm_source: user.utm_source,
                original_utm_medium: user.utm_medium,
                original_utm_term: user.utm_term,
                utm_campaign: sessionStorageWrapper.getItem('utm_campaign'),
                utm_content: sessionStorageWrapper.getItem('utm_content'),
                utm_source: sessionStorageWrapper.getItem('utm_source'),
                utm_medium: sessionStorageWrapper.getItem('utm_medium'),
                utm_term: sessionStorageWrapper.getItem('utm_term'),
              },
            })
          }
        })
        .catch(e => {
          logout()
          if (typeof window !== `undefined`) {
            window.dataLayer.push({
              user: {
                uid: undefined,
                age: undefined,
                date_of_registration: undefined,
                is_guest: true,
                zip: undefined,
                gender: undefined,
                state: undefined,
                original_utm_campaign: undefined,
                original_utm_content: undefined,
                original_utm_source: undefined,
                original_utm_medium: undefined,
                original_utm_term: undefined,
                utm_campaign: undefined,
                utm_content: undefined,
                utm_source: undefined,
                utm_medium: undefined,
                utm_term: undefined,
              },
            })
          }
        })
    }
  }, [isLoggedInBoolean])

  const inlineStyle = `
  .themed-button,
  .themed-button:hover {
      background-color : #4c3371;
      color : #fff;
      border-color : #4c3371; 
  }

  .themed-button-secondary {
    background-color : transparent;
    color : #fff;
    border : 2px solid #4c3371; 
  }

  .themed-secondary {
    background-color : #EEEAF4;
    color : #646464 ;
  }
  `

  return (
    <>
      <span className="shade"></span>
      <style dangerouslySetInnerHTML={{ __html: inlineStyle }} />
      {!hideNav && <Header />}

      {children}

      {!hideFooter && <Footer />}
      <GlobalScripts />
      <Modal />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
